<template>
  <div class="layer layer2">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.product_detail }}</h2>
      <div class="innerContent">
        <div class="mb15">
          <div class="innerTitle setLabel">{{locale.detail_image}}</div>
          <draggable
            v-model="imgList"
            group="imgList"
            animation="300"
            class="imgList">
            <div
              v-for="(img, index) in imgList"
              :key="index"
              class="imgItem"
              :style="{backgroundImage: `url(${img})`}">
              <button type="button" class="btnDel" @click="delImg(index)"></button>
            </div>
            <label v-if="imgList.length <= imgLimit" class="imgItem addImg"><input type="file" @change="uploadImage($event)"></label>
          </draggable>
        </div>
        <div class="flexBox">
          <div class="flexInner">
            <!-- 상세설명용 이름 -->
            <div class="mb15">
              <div class="shopDetailName mb5">
                <div class="innerTitle setLabel">
                  <div class="checkbox">
                    <input type="checkbox" id="active_detail_shopItemName" v-model="localDetailShopItemName.active">
                    <label for="active_detail_shopItemName">{{ locale.product_name_details }}</label>
                  </div>
                </div>
                <SetLanguageValue v-if="localDetailShopItemName.active"
                  :locale="locale"
                  :langValue="localDetailShopItemName.shopItemName"
                  :disabledLangCodes="disabledLangCodes"
                  :textarea="true" />
                <div v-if="isBaseShopPos && localDetailShopItemName.active" class="mt5">
                  <div class="checkbox">
                    <input type="checkbox" id="replace_detail_name_pos" v-model="localDetailShopItemName.allowReplaceItemName">
                    <label for="replace_detail_name_pos">{{ locale.shop_separate_display_name }}</label>
                  </div>
                </div>
              </div>
              <p class="sysMessage">{{ locale.message_detail_product_name }}</p>
            </div>
            <!-- //상세설명용 이름 -->
            <div class="shopOptionList">
              <draggable
                v-model="descriptionList"
                group="descriptionList"
                animation="300"
                class="optionList clickable">
                <div
                  v-for="(item, index) in descriptionList"
                  :key="index"
                  class="optionItem">
                  <button type="button" class="btnHandle"></button>
                  <div v-if="!item.presetId">
                    <div class="innerTitle setLabel">{{locale.detail_desc}}</div>
                    <SetLanguageValue
                      :locale="locale"
                      :langValue="item.desc"
                      :textarea="true" />
                  </div>
                  <div v-else>
                    <button type="button" class="btnDel" @click="delDetails(index)"></button>
                    <span class="stkr">Add</span>
                    {{ item.presetName }}
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="flexInner">
            <div class="innerTitle setLabel">{{locale.addtional_info}}</div>
            <div class="mb5">
              <input type="text" class="input searchInput" v-model="searchItem" placeholder="preset name">
            </div>

            <div class="shopOptionList">
              <ul
                class="optionList clickable">
                <li
                  v-for="(item, index) in filteredDetailPresets"
                  :key="index"
                  class="optionItem"
                  @click="addDetails(item)">
                  {{ item.presetName }}
                </li>
                <li v-if="filteredDetailPresets.length <= 0" class="optionItem">{{locale.additional_info_nodata}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="apply">{{ locale.apply }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'CompositeItemDetail',
  props: [
    'locale',
    'isBaseShopPos',
    'shopItemName',
    'posItemLang',
    'detailShopItemName',
    'desc',
    'descList',
    'detailImage'
  ],
  components: {
    draggable,
    SetLanguageValue
  },
  computed: {
    filteredDetailPresets () {
      const filterIds = this.descriptionList.map(x => x.presetId)
      const word = regExp.replaceAllEmpty(this.searchItem)
      const list = this.detailPresets.filter(x => !filterIds.includes(x.presetId))

      function filterListByWord(list, w) {
        if (!w) return list

        return list.filter(item => {
          // 1) presetName
          if (regExp.replaceAllEmpty(item.presetName).includes(w)) {
            return true
          }

          // 2) title의 모든 언어 값
          if (hasObjectValueMatch(item.title, w)) {
            return true
          }

          // 3) desc의 모든 언어 값
          if (hasObjectValueMatch(item.desc, w)) {
            return true
          }

          return false
        });
      }

      function hasObjectValueMatch(obj, word) {
        if (!obj || typeof obj !== 'object') return false

        return Object.values(obj).some(v =>
          regExp.replaceAllEmpty(v).includes(word)
        );
      }
      return filterListByWord(list, word)
    }
  },
  watch: {
    'localDetailShopItemName.active' (isActive) {
      const current = this.localDetailShopItemName?.shopItemName

      const isEmpty = !current || Object.values(current).every(v => {
        return v === '' || v === null || v === undefined
      })

      if (isActive && isEmpty) {
        this.localDetailShopItemName.shopItemName = this._.cloneDeep(this.shopItemName)
      }
    },
    'localDetailShopItemName.allowReplaceItemName' (isAllowed) {
      this.disabledLangCodes = isAllowed ? [] : this.posItemLang
    }
  },
  async created () {
    this.localDetailShopItemName = this._.cloneDeep(this.detailShopItemName)

    this.descriptionList = this._.cloneDeep(this.descList || [])
    if (!this.descriptionList.find(x => x && x.desc)) {
      this.descriptionList.push({ desc: LANG.valueObj('') })
    }

    if (this.detailImage) {
      this.imgList = this.detailImage
    }

    this.disabledLangCodes = this.localDetailShopItemName.allowReplaceItemName ? [] : (this.posItemLang || [])

    await this.getPresetList()
  },
  data () {
    return {
      localDetailShopItemName: this._.cloneDeep(this.detailShopItemName),
      imgList: [],
      imgLimit: 5,
      detailPresets: [], //
      descriptionList: [],
      searchItem: '',
      disabledLangCodes: []
    }
  },
  methods: {
    async getPresetList () { // 옵션 프리셋 리스트 호출
      this.$store.commit('onLoading', true)
      const getPreset = await this.$store.dispatch('shop/getShopPresetList', 'details')
      const presetList = getPreset && getPreset.message && getPreset.message.preset
      if (presetList) {
        this.detailPresets = presetList
        this.descriptionList = this.descriptionList.filter(item => {
          return item.desc ? true : presetList.find(x => x.presetId === item.presetId)
        })
      }
      this.$store.commit('onLoading', false)
    },
    addDetails (item) {
      this.descriptionList.push({
        presetId: item.presetId,
        presetName: item.presetName
      })
    },
    delDetails (index) {
      this.descriptionList = this.descriptionList.filter((x, i) => i !== index)
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.imgList.push(res.source)
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    delImg (index) {
      this.imgList = this.imgList.filter((x, i) => i !== index)
    },
    close () {
      this.$emit('close')
    },
    apply () {
      let descList
      function normalizeDesc (arr = []) {
        const result = arr.filter(v => {
          if (v && v.presetId) {
            return v
          }

          if (v && typeof v === 'object' && 'desc' in v) {
            return v.desc && Object.keys(v.desc).length > 0
          }

          return false
        })
        return result
      }
      if (this.descriptionList) {
        descList = normalizeDesc(this.descriptionList)
      }
      this.$emit('apply', {
        detailShopItemName: this.localDetailShopItemName,
        desc: this.descriptionList.find(x => x.desc).desc,
        detailImage: this.imgList,
        descList: descList.map(x => {
          return x.desc
            ? { desc: this.$store.getters['util/filteredLanguageValues'](x.desc) }
            : x
        })
      })
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 900px;
  }
}
.imgList {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
  .imgItem {
    position: relative;
    height: 0;
    padding-top: 74%;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    background-color: $color-white;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    background: $color-white url('~@/assets/img/ico_close_black.svg') 50% 50% / 16px no-repeat;
    opacity: 0.6;
  }
  .addImg {
    border-style: dashed;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_plus.svg') 50% 50% / 16px no-repeat;
      opacity: 0.2;
    }
  }
}
.innerContent,
.flexBox,
.flexInner {
  overflow: hidden;
}
.innerContent {
  display: flex;
  flex-direction: column;
}
.flexBox {
  flex: 1;
}
.flexInner {
  display: flex;
  flex-direction: column;
}
</style>
